export default __webpack_public_path__ + "static/media/customize-icon.10551f83.svg";